import { List, ListItemButton, ListItemText } from "@mui/material";
import { PlaygroundPageItem } from "../../constants";
import { convertPascalCaseToWords } from "@/utils";

export default function PlaygroundPageList({ pages }: { pages: PlaygroundPageItem[] }) {
  return (
    <>
      <List>
        {pages
          .toSorted((a, b) => (a.name > b.name ? 1 : -1))
          .map((page) => {
            const pageName = page.name;
            return (
              <ListItemButton key={pageName} href={`/playground/${pageName}`}>
                <ListItemText>
                  {convertPascalCaseToWords(pageName)}
                </ListItemText>
              </ListItemButton>
            );
          })}
      </List>
    </>
  );
}
